const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

async function post(path, body) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (res.status === 429) {
    throw new Error("Çok fazla istek gönderdiniz. Lütfen birkaç dakika sonra tekrar deneyin.");
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || "İstek başarısız oldu. Lütfen tekrar deneyin.");
  return data;
}

export const postContact = (b) => post("/contact", b);
export const postNewsletter = (b) => post("/newsletter", b);
export const postQuote = (b) => post("/quote", b);

export const getReviews = async () => {
  const res = await fetch(`${API}/reviews`);
  if (!res.ok) throw new Error("reviews-failed");
  return res.json();
};
